"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AoMesher_1 = require('./AoMesher');
// Retrieves the texture for a voxel
function voxelTexture(voxel, side, voxelSideTextureIDs) {
    return voxelSideTextureIDs ? voxelSideTextureIDs.get(voxel, side) : voxel;
}
function voxelTextureSizeLg(voxel, side, voxelSideTextureSizes) {
    return voxelSideTextureSizes ? voxelSideTextureSizes.get(voxel, side) : 4; // power of 2 (2^4=16)
}
var TexturedAoMesher = (function (_super) {
    __extends(TexturedAoMesher, _super);
    function TexturedAoMesher() {
        // TODO: Use openEnd (requires pad filling)
        _super.call(this, false);
    }
    TexturedAoMesher.prototype.build = function (gl, padded, voxelSideTextureIDs, voxelSideTextureSizes) {
        this.voxelSideTextureIDs = voxelSideTextureIDs;
        this.voxelSideTextureSizes = voxelSideTextureSizes;
        var vao = this.createVao(gl, padded);
        this.voxelSideTextureIDs = null;
        this.voxelSideTextureSizes = null;
        return vao;
    };
    TexturedAoMesher.prototype.getVertexData = function (data, val) {
        var side = this.d + (this.flip ? 3 : 0);
        var tex_id = voxelTexture(val, side, this.voxelSideTextureIDs);
        var hi_tex_id = tex_id >> 8;
        var lo_tex_id = tex_id & 0xff;
        var tex_size = voxelTextureSizeLg(val, side, this.voxelSideTextureSizes);
        data[0] = tex_size;
        data[1] = hi_tex_id;
        data[2] = lo_tex_id;
    };
    return TexturedAoMesher;
}(AoMesher_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = TexturedAoMesher;
//# sourceMappingURL=TexturedAoMesher.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/lib/meshers/TexturedAoMesher.js
 ** module id = 935
 ** module chunks = 0
 **/